import * as React from 'react';
import { ClassicListView } from './themes/ClassicListView';
import { useSelector } from 'react-redux';
import { selectIsModernDesignAvailable } from '../../../../selectors';
import { SectionContainer } from '../Section';
import { ModernListView } from './themes/ModernListView';

/**
 * В рамках проекта по редизайну смарт-пакетов https://jira.cian.tech/browse/MONEY-655
 * был разработан новый дизайн для таблиц состава пакета/подписки. Изменения в проекте
 * касались только смарт-пакетов, но планируется распространить обновление и на другие
 * типы. Соответственно, потребовалось отделить старый дизайн от нового. Для этого все
 * старые компоненты были собраны в одной папке ClassicListView, новые компоненты —
 * в папке ModernListView, а отображением занимается ContentContainer.
 * Такие названия были выбраны из-за подобия представлений скинам/темам во всевозможных программах.
 */
export const ContentContainer = () => {
  const isNewDesignAvailable = useSelector(selectIsModernDesignAvailable);

  if (isNewDesignAvailable) {
    return (
      <SectionContainer>
        <ModernListView />
      </SectionContainer>
    );
  }

  return (
    <SectionContainer>
      <ClassicListView />
    </SectionContainer>
  );
};
